import { ListItemTextProps, ListItemText as MuiListItemText } from "@mui/material";

type Props = ListItemTextProps;

export const ListItemText = ({ children, ...props }: Props) => {
  return <MuiListItemText {...props}>{children}</MuiListItemText>;
};
